import React from "react";

/** Catches render crashes for a single feed row without killing the page. */
export class InlineErrorBoundary extends React.Component<
  { children: React.ReactNode; fallback?: React.ReactNode },
  { hasError: boolean }
> {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(err: Error) {
    console.warn("[FeedItem] render error caught:", err.message);
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback ?? (
          <div className="text-[11px] text-muted-foreground/80 italic py-1 px-2">
            Failed to render
          </div>
        )
      );
    }
    return this.props.children;
  }
}
